import React from 'react'
import { useSidePanel } from '@node-space/storybook-components/dist/SidePanel'
import { Customer } from 'types/customers'
import { EmbeddedCustomer } from '../helpers/types'
import { getMappedCustomerList } from '../helpers/utils'
import { EmbeddedCustomerDetails } from './EmbeddedCustomerDetails'
import { EmbeddedCustomersList } from './EmbeddedCustomersList'

export interface CustomerResultsViewProps {
  customersData: Customer[]
}

export const CustomerResultsView = ({ customersData }: CustomerResultsViewProps) => {
  const customers: EmbeddedCustomer[] = getMappedCustomerList(customersData)

  const {
    isSidePanelOpen: isCustomerDetailsOpen,
    sidePanelData: customerDetails,
    paging: pageCustomers,
    setIsSidePanelOpen: setIsCustomerDetailsOpen,
    updateSidePanel: updateCustomerDetails,
  } = useSidePanel<EmbeddedCustomer>(customers)

  const handleOpenCustomerDetails = (customerIndex: number) => {
    setIsCustomerDetailsOpen(true)
    updateCustomerDetails(customerIndex)
  }

  const handleCloseCustomerDetails = () => {
    setIsCustomerDetailsOpen(false)
  }

  return (
    <>
      <EmbeddedCustomersList customers={customers} onOpenDetails={handleOpenCustomerDetails} />
      <EmbeddedCustomerDetails
        isOpen={isCustomerDetailsOpen}
        onClose={handleCloseCustomerDetails}
        pageCustomers={pageCustomers}
        customerDetails={customerDetails}
      />
    </>
  )
}
